import Blog from "../../components/blogs/blog";
import CustomMetas from "../../components/custom-metas";
import { BLOG_POST } from "../../graphql/blogs/queries";
import { getClient } from "../../Providers/graphqlClient";

const BlogPage = ({ blog }) => {
    return (
        <>
            <CustomMetas title={blog.meta_title}
                description={blog.meta_description}
                keywords={blog.meta_keywords}
                page_type="catalogs"
                url={process.env.NEXT_PUBLIC_STORE_FRONT + "/blogs/" + blog.url_key + `.html`}
            />
            <Blog blog={blog} />
        </>
    );
}

export default BlogPage;


export const getStaticPaths = async () => {
    return {
        paths: [],
        fallback: 'blocking'
    }
}

export const getStaticProps = async (context) => {

    const { params, locales, locale } = context

    const client = getClient(locale)

    const { data } = await client.query({
        query: BLOG_POST,
        variables: {
            url_key: params.slug,
            store_ids: (locales.indexOf(locale) + 1).toString()
        },
        revalidate: 30
    })

    if (data.blogPost.items.length === 0) {
        return {
            notFound: true,
            revalidate: 10
        }
    }

    return {
        props: {
            blog: data.blogPost.items[0],
        },
        revalidate: 10
    }
}